/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelNav64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelNav64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.1"
            d="M2 24C2 21.7909 3.79086 20 6 20H58C60.2091 20 62 21.7909 62 24V40C62 42.2091 60.2091 44 58 44H6C3.79086 44 2 42.2091 2 40V24Z"
            fill="currentColor"
          />
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.6465 25.6464C13.8417 25.4512 14.1583 25.4512 14.3536 25.6464L20.8536 32.1464L20.1465 32.8536L19 31.7071V36C19 36.5523 18.5523 37 18 37H10C9.44775 37 9.00004 36.5523 9.00004 36V31.7071L7.85359 32.8536L7.14648 32.1464L13.6465 25.6464ZM14 26.7071L18 30.7071V36H10V30.7071L14 26.7071Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6 20C3.79086 20 2 21.7909 2 24V40C2 42.2091 3.79086 44 6 44H58C60.2091 44 62 42.2091 62 40V24C62 21.7909 60.2091 20 58 20H6ZM58 21H6C4.34315 21 3 22.3431 3 24V40C3 41.6569 4.34315 43 6 43H58C59.6569 43 61 41.6569 61 40V24C61 22.3431 59.6569 21 58 21Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelNav64Icon.tags = ['add', 'menu', 'interface', 'plus', 'create'];

AddPanelNav64Icon.category = '64x64 (Add panel)';

AddPanelNav64Icon.iconSize = 64;
